import { Card, CardContent } from "@/components/ui/card";

const FightAgainstBlight = () => {
  return (
    <Card className="overflow-hidden">
      <CardContent className="p-8">
        <h2 className="text-3xl font-bold mb-6 text-primary">Fight Against Blight</h2>
        <p className="text-gray-600 mb-4">
          SPO continue to support The James Hutton Institute to continue in its role to help protect Britain's potato crop against late blight.
        </p>
        <p className="text-gray-600 mb-4">
          The FAB scheme was first launched in 2006, using the monitoring of Phytophthora infestans populations via a nationwide network of agronomists, growers, and industry representatives (the FAB Scouts). This network annually submits up to 1,500 field samples from suspected late blight outbreaks throughout Britain.
        </p>
        <p className="text-gray-600">
          The work led by Dr David Cooke and Dr Alison Lees from The James Hutton Institute includes both the annual sampling of late blight outbreaks, the characterisation of pathogen populations, as well as fungicide sensitivity testing on active ingredients prioritised by the industry.
        </p>
      </CardContent>
    </Card>
  );
};

export default FightAgainstBlight;